import { HomeScreen } from '@strata/react-page-templates';

import { AppRoutes } from 'services/routes';
import { useGetHomeScreenMessagesQuery } from 'store/api/announcementApi';

export const Home = () => {
    const { data: messages } = useGetHomeScreenMessagesQuery();

    return (
        <HomeScreen
            illustration={HomeScreen.Illustration.LIGHTHOUSE}
            welcomeMessagePartOne="Free Market Health's Lighthouse application enables a single access point for Prescribers and Pharmacies to facilitate Prior Auth requests. The application seamlessly guides FMH users through each step of the Prior Auth process, reducing the complexity of navigating from initiation to submission to a Payer. Lighthouse enhances the FMH ecosystem by further complimenting the value created by the care-driven marketplace, delivering a simplified experience for payers, providers, and members."
            messages={messages}
            viewAllUpdatesUrl={AppRoutes.updatesHistory}
            button={{ path: AppRoutes.intakeForm, label: 'View Intake Form' }}
        />
    );
};
